import React from "react";
import { useNavigation } from "./Hooks";
import { NavigationPiece, NavProps } from "./Pieces";
export default function NavigationComponent(props: NavProps) {
  const links = useNavigation();
  return <NavigationPiece {...props} links={links} />;
}
